module.exports = __webpack_public_path__ + "img/spring_trip-20160416-4-768x1024.1467ff02.jpg";